import React from 'react'
import styled from 'styled-components'

import DeveloperApproachSubSection, {
  StyledDeveloperApproachTitle,
} from 'components/page/Section/DeveloperApproachSubSection'

import IconRocket from '@anvilco-pkg/ui/components/Icon/IconRocket'
import IconOpenBook from '@anvilco-pkg/ui/components/Icon/IconOpenBook'
import IconCode from '@anvilco-pkg/ui/components/Icon/IconCode'
import IconReact from '@anvilco-pkg/ui/components/Icon/IconReact'
import IconWebform from '@anvilco-pkg/ui/components/Icon/IconWebform'
import IconWebhook from '@anvilco-pkg/ui/components/Icon/IconWebhook'

import { GREEN_UNDERLINE } from 'consts'

const StyledDeveloperApproachSubSection = styled(DeveloperApproachSubSection)`
  ${StyledDeveloperApproachTitle} {
    text-align: center;
  }
`

const items = [
  {
    title: 'Quickstart',
    description:
      'Integrate e-signatures into your app with just a few lines of code.',
    icon: <IconRocket />,
    to: `/docs/api/e-signatures/#quick-start`,
  },
  {
    title: 'React embed components',
    description:
      'Use our React components to embed your Webform and receive notifications.',
    icon: <IconReact />,
    to: `https://github.com/anvilco/react-ui`,
  },
  {
    title: 'Webform webhook notifications',
    description:
      'Get notified via webhooks when users submit data to your webforms.',
    icon: <IconWebhook />,
    to: `/docs/api/workflows/#webhook-notifications`,
  },
  {
    title: 'Language-specific API clients',
    description: 'Connect to our API with the language of your choice.',
    icon: <IconCode />,
    to: `/open-source/`,
  },
  {
    title: 'Workflows API guide',
    description: 'Get the full details on integrating Webforms into your app.',
    icon: <IconWebform />,
    to: `/docs/api/workflows/`,
  },
  {
    title: 'API Documentation',
    description:
      'Find detailed documentation, references, and step-by-step tutorials all in one place.',
    icon: <IconOpenBook />,
    to: `/docs/`,
  },
]

const DeveloperApproach = () => (
  <StyledDeveloperApproachSubSection
    title={
      <>
        A <span className={GREEN_UNDERLINE}>developer-first</span> approach to
        paperwork
      </>
    }
    items={items}
  />
)

export default DeveloperApproach
